import React from 'react';
import classnames from 'classnames';
import FontAwesome from 'react-fontawesome';

import styles from './select.less';

const SearchArrowRenderer = ({ className }) => {
  const _className = classnames(styles['search-arrow-renderer'], className);

  return <FontAwesome className={_className} name="search" />;
};

SearchArrowRenderer.propTypes = {
  ...FontAwesome.propTypes,
};

SearchArrowRenderer.defaultProps = {
  ...FontAwesome.defaultProps,
};

export default SearchArrowRenderer;
export { SearchArrowRenderer };
